import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { Layout, AppProvider, ProgressBar } from "@shopify/polaris";
import enTranslations from "@shopify/polaris/locales/en.json";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllAppsDashboard,
  getUserDetailDashboard,
} from "../../../services/seller/api";
import React from "react";
import PopularApps from "../../../seller_components/popular_apps/popular_apps";
import ImageSlider from "../../../components/image_slider/image_slider";
import AdvantageBanner from "../../../seller_components/advantage_banner/advantage_banner";
import PartnerBanner from "../../../seller_components/partner_section/partner_banner";
import SpecialBanner from "../../../seller_components/special_banner/special_banner";
import SponsoredApps from "../../../seller_components/sponsored_app/sponsored_app";
import DetailSkeleton from "../../../skeleton/DetailSkeleton";
import { useNavigate } from "react-router-dom";
import {
  fetchDataFailure,
  fetchDataStart,
  fetchDataSuccess,
} from "../../../store/slice/apps_dashboard_slice";
import {Helmet} from "react-helmet";
import AllApps from "../../../seller_components/all_apps/all_apps";
import ShipingBanner from "../../../seller_components/shiping_banner/shiping_banner";
import Fotter from "../../../layout/fotter";

import { headerText } from "../../../../assets";
import "../seller_dashboard/seller.scss"
import AppData from "../../../components/interface/nav_bar_Interface/nav_bar_interface";
import { captureGAEvent, gaPanelConfig } from "../../../shared/helper";
import SliderValueLabel from "@mui/material/Slider/SliderValueLabel";
import { clearEvents } from "../../../utils/changeHeaderColor";

const SellerDashboard = () => {
  const { t } = useTranslation("translation", {
    keyPrefix: "home",
  });
  gaPanelConfig.select_item = "";
  gaPanelConfig.select_result = "";
  gaPanelConfig.search_term = "";
  const [dashboardData, setDashboardData] = useState<any>();
  const [isSkeletonVisible, setIsSkeletonVisible] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state: any) => state.auth);
  // localStorage.removeItem('slug');


  const navigateToAppDetails = (slug: string, appName: string, appStatus: string, cardSection: string) => {
    clearEvents()
    gaPanelConfig.AppName = appName;
    gaPanelConfig.AppStatus = appStatus;
    gaPanelConfig.CardSection = cardSection;
    gaPanelConfig.AppSlug = slug;
    sendGAEvent('sras_app_card_click');

    // navigate(`/${slug}`);

    // window.location.href = `/${slug}`;
    const newUrl = `/${slug}`;

    // Push the new URL to the browser history without reloading the page
    window.history.pushState({ path: newUrl }, '', newUrl);
    window.dispatchEvent(new Event('popstate'));
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  const sendGAEvent = (event: string) => {
    captureGAEvent(event, event);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(fetchDataStart());
        console.log("Fetching data...");
        // console.log("Fetching authToken => " + auth.token);
        if (auth.token != null) {
          // const userDetailResponse = await getUserDetail();
          // setUserDetails(userDetailResponse.data);
        }
        const response = await getUserDetailDashboard();
        // console.log("Fetched dashboard data:", response.data);
        dispatch(fetchDataSuccess(response.data));
        setDashboardData(response.data);
        setIsSkeletonVisible(false);
      } catch (error: any) {
        console.error("Error fetching dashboard data:", error);
        dispatch(fetchDataFailure(error.message));
        setError("Something went wrong. Please try again later.");
      }
    };

   fetchData();
  }, [auth.token]);

  if (isSkeletonVisible) {
    return <DetailSkeleton />;
  }
  if (!auth) {
    return <div style={{ marginTop: "25%", textAlign: "center" }}>Loading...</div>;
  }

  if (error) {
    return <div style={{ marginTop: "25%", }}>{error}</div>;
  }
  sendGAEvent("sras_page_view");
  return (

    <>
           <Helmet>
                <meta charSet="utf-8" />
                <title>App Store</title>
             
            </Helmet>
      <div>
        <div>
          <div className="hidden md:block">
            <div className="imageHeader" >
              <div className="hero">
                <div className="container">
                  <div style={{ pointerEvents: "none" }} className="center-align flex flex-col justify-center">
                    <button className="circular-button">Unlock Your D2C Success</button>
                    <img
                      style={{ marginLeft: "20%", marginRight: "20%", marginTop: "50px", width: "620px" }}
                      src={headerText}
                      alt="headerText"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Second div - Show on mobile view */}
          <div className="block md:hidden">
            <div className="imageHeader" >
              <div className="heroM">
                <div className="container">
                  <div className="center-align flex flex-col justify-center">
                    <button className="circular-button">Unlock Your D2C Success</button>
                    <img
                      style={{ paddingLeft: "20%", paddingRight: "20%", paddingTop: "50px", }}
                      src={headerText}
                      alt="headerText"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="Section" style={{ background: "#f9f9fc" }}>
            <div className="container">
              <AllApps
                mainTitle={"Popular Apps"}
                onAppCardClick={navigateToAppDetails}
              />
            </div>
            {dashboardData &&
              (
                <div >
                  <AdvantageBanner data={dashboardData.sections[0]} />
                </div>
              )}
            {dashboardData &&
              dashboardData.sections[0].apps && (
                <div style={{ marginTop: "54px" }} className="container">
                  <SponsoredApps
                    mainTitle={dashboardData.sections[0].title}
                    sponsoredApps={dashboardData.sections[0].apps}
                    onAppCardClick={navigateToAppDetails}
                  />
                </div>
              )}
            <div style={{ marginTop: "54px" }} className="container">
              <ShipingBanner />
            </div>
            <div style={{ marginBottom: "20px" }} className="container">
              <PartnerBanner />
            </div>
          </div>
        </div>
      </div>
      <div>
        <Fotter />
      </div>
    </>
  );
};

export default SellerDashboard;
